class StudyPlannerScheduler {

    constructor() {
    }

    createSchedule() {
        this.schedule = new Schedule();
        this.addSleepToSchedule();
        this.addWorkAndCommuteToSchedule();
        this.addGettingReadyToSchedule();
        this.addFamilyTimeToSchedule();
        this.addLifestyleActivitiesToSchedule();
        this.addStudyTimeToSchedule();
        appLogObject('StudyPlannerScheduler', 'schedule', this.schedule.toJSON());
        return this.schedule;
    }

    addSleepToSchedule() {
        let dailyRoutine = plannerApplication.studyPlannerProfile.getDailyRoutine();
        this.dayStartTime = dailyRoutine.getBeginDay();
        this.dayEndTime = dailyRoutine.getEndDay();
        if (this.dayStartTime > this.dayEndTime) {
            this.dayStartTime = dailyRoutine.getEndDay();
            this.dayEndTime = dailyRoutine.getBeginDay();
        }
        this.#allocateForWeek(ScheduleType.sleep, 0, this.dayStartTime);
        this.#allocateForWeek(ScheduleType.sleep, this.dayEndTime, toMinutes(24, 0));
    }

    addGettingReadyToSchedule() {
        this.#allocateForWeek(
            ScheduleType.gettingReady,
            this.dayStartTime,
            this.dayStartTime + appConfig.schedule.morningGetReadyMins);

        this.#forEachDay(function (day) {
            let daySchedule = this.schedule.forDay(day);
            let sleep = daySchedule[0];
            let gettingReady = daySchedule[1];
            if (gettingReady.getDuration() !== appConfig.schedule.morningGetReadyMins) {
                let diff = appConfig.schedule.morningGetReadyMins - gettingReady.getDuration();
                sleep.adjustTimes(
                    sleep.getStartTime(),
                    sleep.getEndTime() - diff,
                );
                gettingReady.adjustTimes(
                    gettingReady.getStartTime() - diff,
                    gettingReady.getEndTime()
                );
            }
        }.bind(this));
    }

    addWorkAndCommuteToSchedule() {
        this.addWorkFromHomeToSchedule();
        this.addWorkAtOfficeAndCommuteToSchedule();
    }

    addWorkFromHomeToSchedule() {
        let work = plannerApplication.studyPlannerProfile.getWork();
        this.#allocateForWeek(ScheduleType.workHome,
            work.getStartTimeFromHome(),
            work.getStartTimeFromHome() + work.getDurationFromHome(),
            work.getDaysAWeekFromHome());

    }

    addWorkAtOfficeAndCommuteToSchedule() {
        let work = plannerApplication.studyPlannerProfile.getWork();
        let commuting = plannerApplication.studyPlannerProfile.getCommuting();
        let commutingTime = commuting.getDuration();
        this.#allocateForWeek(ScheduleType.commuting,
            work.getStartTimeInOffice() - commutingTime,
            work.getStartTimeInOffice(),
            work.getDaysAWeekInOffice());

        this.#allocateForWeek(ScheduleType.workOffice,
            work.getStartTimeInOffice(),
            work.getStartTimeInOffice() + work.getDurationInOffice(),
            work.getDaysAWeekInOffice());

        this.#allocateForWeek(ScheduleType.commuting,
            work.getStartTimeInOffice() + work.getDurationInOffice(),
            work.getStartTimeInOffice() + work.getDurationInOffice() + commutingTime,
            work.getDaysAWeekInOffice());
    }

    addFamilyTimeToSchedule() {
        let family = plannerApplication.studyPlannerProfile.getFamily();
        let dailyPartnerTime = family.isInRelationship() ? family.getTimeWithPartner() * 60 : 0;

        this.#forEachDay(function (day) {
            let dailyTime = dailyPartnerTime;
            if (family.hasDependentChildren()) {
                family.getChildActivities().each(function (childActivity) {
                    if (childActivity.getDays().indexOf(day) !== -1) {
                        dailyTime += childActivity.getHours() * 60
                    }
                });
            }
            this.#allocateToGaps(day, dailyTime, ScheduleType.family);
        }.bind(this));
    }

    addLifestyleActivitiesToSchedule() {
        let lifestyle = plannerApplication.studyPlannerProfile.getLifestyle();
        lifestyle.getActivities().each(function (lifestyleItem) {
            let index = lifestyle.getActivities().indexOf(lifestyleItem);
            if (lifestyleItem.isSelected()) {
                _.each(lifestyleItem.getDays(), function (day) {

                    this.#allocateToGaps(day, lifestyleItem.getDuration(), ScheduleType.lifestyle, index);

                }.bind(this));
            }
        }.bind(this));
    }

    addStudyTimeToSchedule() {
        let studyTimeToAdd = plannerApplication.yourProfile.getSelectedCourse().getHours() * 60;
        this.#forEachDay(function (day) {
            studyTimeToAdd = this.#allocateToGaps(day, studyTimeToAdd, ScheduleType.study);
        }.bind(this));
    }

    #allocateToGaps(day, timeToAllocate, scheduleType, lifestyleNo) {
        if(day === 7) {
            day = 0;
        }
        let scheduleForDay = this.schedule.forDay(day);
        for (let i = 0; i < scheduleForDay.length - 1; i++) {
            let thisItem = scheduleForDay[i];
            let nextItem = (i + 1 === scheduleForDay.length) ? null : scheduleForDay[i + 1];

            let gapMins = nextItem != null ?
                nextItem.getStartTime() - thisItem.getEndTime() :
                toMinutes(24, 0) - thisItem.getEndTime();

            if (gapMins >= 30 && timeToAllocate > 0) {
                let allocating = gapMins;
                if (timeToAllocate < allocating) {
                    allocating = timeToAllocate;
                }
                if (allocating > timeToAllocate) {
                    allocating = timeToAllocate;
                }

                this.schedule.addItem(
                    CreateScheduleItem(
                        scheduleType,
                        day,
                        scheduleForDay[i].getEndTime(),
                        scheduleForDay[i].getEndTime() + allocating,
                        lifestyleNo));
                timeToAllocate -= allocating;
            }
        }
        return timeToAllocate;
    }

    #allocateForWeek(scheduleType, startTime, endTime, limitToDays) {
        limitToDays = nullIfUndefined(limitToDays);
        this.#forEachDay(function (day) {
            if (limitToDays == null || limitToDays.indexOf(day) !== -1) {
                let scheduleForDay = this.schedule.forDay(day);
                let adjustStartTime = this.#findStartFreeTime(scheduleForDay, day, startTime);
                let adjustEndTime = endTime + (adjustStartTime - startTime);
                adjustEndTime = this.#findEndFreeTime(day, adjustEndTime);
                this.schedule.addItem(CreateScheduleItem(scheduleType, day, adjustStartTime, adjustEndTime))
            }
        }.bind(this));
    }

    #findStartFreeTime(scheduleForDay, day, startTime) {
        _.each(scheduleForDay, function (scheduleItem) {
            if (scheduleItem.getStartTime() < startTime && startTime < scheduleItem.getEndTime()) {
                startTime = scheduleItem.getEndTime();
            }
        });
        return startTime;
    }

    #findEndFreeTime(day, endTime) {
        let scheduleForDay = this.schedule.getItems().filter((x) => x.getDay() === day);
        _.each(scheduleForDay, function (scheduleItem) {
            if (scheduleItem.getStartTime() < endTime && endTime < scheduleItem.getEndTime()) {
                endTime = scheduleItem.getStartTime();
            }
        });
        return endTime;
    }

    #forEachDay(dayFn) {
        for (let day = 0; day < 7; day++) {
            dayFn(day);
        }
    }

}
